import {useMutation, useQueryClient} from 'react-query';
import {AxiosError} from 'axios';
import {toast} from 'react-toastify';
import {patchBasket} from './patchBasket';

export interface IPatchBasketPayload {
  quantity: number;
  basket_guid: string;
}
const usePatchBasket = (
  handleAfterSuccess?: (variables: IPatchBasketPayload) => void,
) => {
  const queryClient = useQueryClient();

  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (payload: IPatchBasketPayload) => patchBasket(payload),

    onSuccess: (_, variables) => {
      // pass variables out
      handleAfterSuccess?.(variables);
      queryClient.invalidateQueries(['get-basket']);
      queryClient.invalidateQueries(['get-basket-count']);
      queryClient.invalidateQueries(['get-cart-detail-list']);
      queryClient.invalidateQueries(['get-shop-advertisements-by-input']);
      queryClient.invalidateQueries(['get-subBrand-advertisement-list']);
    },

    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoading, mutate, isSuccess};
};

export default usePatchBasket;
